import React from 'react'
import { memo } from '~/ui/component'
import { Center, HBox, Label, Panel, SVG, TextBlock, VBox } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'
import ImageView from './ImageView'

export interface Props {
  url:          string
  image?:       string
  title?:       string
  description?: string
}

const LinkView = memo('LinkView', (props: Props) => {

  const {url, image, title, description} = props

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <Panel href={url} classNames={$.LinkView}>
        <HBox align='stretch'>
          {renderImage()}
          {renderBody()}
          {renderChevron()}
        </HBox>
      </Panel>
    )
  }

  function renderImage() {
    return (
      <VBox classNames={$.image}>
        {image == null ? (
          <Center flex aria-hidden>
            <SVG name='link' size={layout.icon.xxl}/>
          </Center>
        ) : (
          <ImageView
            flex
            objectFit='cover'
            source={image}
          />
        )}
      </VBox>
    )

  }

  function renderBody() {
    return (
      <VBox flex padding={layout.padding.m} gap={layout.padding.inline.s}>
        <Label truncate={false} bold convertNewlines>
          {title ?? url}
        </Label>
        <TextBlock dim small>
          {description}
        </TextBlock>
      </VBox>
    )
  }

  function renderChevron() {
    return (
      <Center padding={layout.padding.s}>
        <SVG dim name='chevron-right' size={layout.icon.l} />
      </Center>
    )
  }

  return render()

})

export default LinkView

const minHeight = 100

const useStyles = createUseStyles(theme => ({
  LinkView: {
  },

  image: {
    backgroundColor: theme.colors.grayScale.light[1],
    width: minHeight * 2,
    minHeight: minHeight,
    maxWidth: '40%',
  },
}))